import { Link as LinkRouter } from 'react-router-dom';
import styled from 'styled-components';

export const LinkStyled = styled(LinkRouter)`
  color: inherit;
  background-color: inherit;

  &:hover {
    color: inherit;
    text-decoration: none;
  }
`;
